import { CardType } from "core/types";
export function teamToTeamView(team) {
    return {
        uuid: team.uuid,
        title: team.title,
        image: team.image,
        members: team.members
            ? team.members.map(function (member) { return personToPersonCard(member); })
            : [],
    };
}
export function personToPersonCard(person) {
    return {
        uuid: person.uuid,
        title: person.title,
        image: person.image,
        kind: person.__typename,
        caption: person.description,
        isInactive: person.isInactive,
        type: CardType.Person,
        description: person.description,
    };
}
